import React from 'react'
import { motion } from 'framer-motion'
import InputForm from '@/components/shared/components/inputForm'
import TextArea from '@/components/shared/components/inputForm/textArea'
import SelectAic from '@/components/shared/components/selectAic'
import Button from '@/components/shared/components/Button/Button'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import schema from './schemaFormContactUs'
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'
import useCustomEndpoint, { VALID_ENDPOINTS } from '@/hooks/useCustomEndpoint'
import PropTypes from 'prop-types'
// styles
import '../styles.cus.scss'
import { get } from 'lodash'

const FormContactUs = ({ optionList, onSubmitForm, setGlobalLoadingFrom }) => {
  const {
    handleSubmit,
    setValue,
    register,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  })
  const errorEmail = get(errors, ['email'], null)
  const errorFullName = get(errors, ['fullName'], null)
  const errorInterested = get(errors, ['interested'], null)
  const errorMessage = get(errors, ['message'], null)
  const { executeRecaptcha } = useGoogleReCaptcha()
  const { reFetchData: fetchRecaptcha } = useCustomEndpoint({
    fetchOnMount: false,
  })

  const onSubmit = async (dataForm) => {
    if (executeRecaptcha) {
      const token = await executeRecaptcha('submit')
      setGlobalLoadingFrom(true)
      if (token) {
        const dataValidation = await fetchRecaptcha({
          type: VALID_ENDPOINTS.captchaVerified,
          params: { token: token },
        })

        if (get(dataValidation, ['success'], false)) {
          onSubmitForm(dataForm)
        }
      }
    }
  }

  return (
    <motion.div
      transition={{
        duration: 0.7,
        delay: 0.5,
      }}
      viewport={{
        once: true,
      }}
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      exit={{ opacity: 1 }}
      className="containerFrom"
    >
      <form onSubmit={handleSubmit(onSubmit)} className="formContactUs">
        <div className="colInputs">
          <InputForm
            isError={!!errorFullName}
            errorMessage={errorFullName?.message}
            register={register('fullName')}
            labelText="Full Name"
            placeholder="First Name and Last Name"
          />
          <InputForm
            isError={!!errorEmail}
            errorMessage={errorEmail?.message}
            register={register('email')}
            labelText="Email"
            placeholder="abc@gmail.com"
          />
          <div className="containerSelectForm">
            <label htmlFor="">Interested Department</label>
            <SelectAic
              isError={!!errorInterested}
              className="!w-full"
              placeholder="Select Department"
              options={optionList}
              onChange={(valueSelect) => {
                setValue('interested', valueSelect.value)
              }}
            />
            {errorInterested ? (
              <span className="ml-[30px] paragraph text-red-500 text-lg">
                {errorInterested.message}
              </span>
            ) : null}
          </div>
        </div>
        <div className="colInputs !gap-[57px] lg:!gap-[61px]">
          <TextArea
            isError={!!errorMessage}
            errorMessage={errorMessage?.message}
            labelText="Message"
            placeholder="Why do you want to join us?"
            register={register('message')}
          />
          <Button
            className="h-[58px] !w-full flex justify-center"
            variant="filled"
            isSubmit
            name="Send message"
            type="submit"
            showLabel
          />
        </div>
      </form>
    </motion.div>
  )
}

FormContactUs.propTypes = {
  optionList: PropTypes.array,
  onSubmitForm: PropTypes.func,
  setGlobalLoadingFrom: PropTypes.func,
}

export default FormContactUs
